import React from 'react';
import styles from './ErrorDisplay.styl';
import {ErrorInfoIcon} from '../Svgs';

const ErrorDisplay = props => {
  const {isFallback} = props;

  return isFallback ? (
    <div className={styles.ErrorDisplay}>
      <ErrorInfoIcon />
      <p className={styles.header}>Oops! Something went wrong.</p>
      <p>
        {' '}
        We are unable to access the Guest Book at this time. Please try again
        later.
      </p>
    </div>
  ) : null;
};

ErrorDisplay.propTypes = {
  isFallback: React.PropTypes.bool,
};

export default ErrorDisplay;



// WEBPACK FOOTER //
// ./src/reactModules/shared/ErrorDisplay/ErrorDisplay.js